export default __webpack_public_path__ + "static/media/yale.33ca3bfa.png";